import type { FC, SVGProps } from 'react';

export const EyeIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="36"
      height="36"
      fill="currentColor"
      viewBox="0 0 36 36"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillOpacity="0.85"
        fill="currentColor"
        d="M35.285 16.9659C31.4761 8.94224 25.7185 4.9043 18.0002 4.9043C10.2779 4.9043 4.52433 8.94224 0.715403 16.9699C0.562626 17.2934 0.483391 17.6468 0.483391 18.0045C0.483391 18.3623 0.562626 18.7156 0.715403 19.0391C4.52433 27.0628 10.2819 31.1007 18.0002 31.1007C25.7225 31.1007 31.4761 27.0628 35.285 19.0351C35.5944 18.3842 35.5944 17.6289 35.285 16.9659ZM18.0002 28.2079C11.5194 28.2079 6.77433 24.9213 3.42746 18.0025C6.77433 11.0838 11.5194 7.79715 18.0002 7.79715C24.481 7.79715 29.2261 11.0838 32.573 18.0025C29.2301 24.9213 24.485 28.2079 18.0002 28.2079ZM17.8395 10.9311C13.9342 10.9311 10.7681 14.0972 10.7681 18.0025C10.7681 21.9079 13.9342 25.0739 17.8395 25.0739C21.7449 25.0739 24.9109 21.9079 24.9109 18.0025C24.9109 14.0972 21.7449 10.9311 17.8395 10.9311ZM17.8395 22.5025C15.3525 22.5025 13.3395 20.4896 13.3395 18.0025C13.3395 15.5155 15.3525 13.5025 17.8395 13.5025C20.3266 13.5025 22.3395 15.5155 22.3395 18.0025C22.3395 20.4896 20.3266 22.5025 17.8395 22.5025Z"
      />
    </svg>
  );
};
